<template>
  <div class="card my-2">
    <div class="card-body p-3">
      <div class="form-group">
        <label for="barcodeType">
          barcode type
        </label>
        <select id="barcodeType" class="form-control" :value="selectedTypeValue" v-on:change="SelectType($event)">
          <option value=""></option>
          <option v-for="barcodeType in barcodeTypes" v-bind:key="barcodeType.name" :value="barcodeType.name">{{barcodeType.name}}</option>
        </select>
      </div>
      <div class="form-group" v-if="displayBarcodeLength">
        <label>Barcode length</label>
        <input type="number" class="form-control" v-on:keyup="updateRange" v-model="size">
      </div>
      <div class="row" v-if="selectedType">
        <div class="col-md-6">
          <label>Start number ({{barcodeLength}} digits)</label>
          <input type="text" class="form-control"
                 v-bind:class="{ 'is-invalid': isInvalidStart }"
                 v-on:keyup="updateRange"
                 v-model="start"
                 :maxlength="barcodeLength"
          >
          <div class="invalid-feedback" v-if="isInvalidStart">
            invalid barcode
          </div>
        </div>
        <div class="col-md-6">
          <label>End number ({{barcodeLength}} digits)</label>
          <input type="text" class="form-control"
                 v-bind:class="{ 'is-invalid': isInvalidEnd }"
                 v-on:keyup="updateRange"
                 v-model="end"
                 :maxlength="barcodeLength">
          <div class="invalid-feedback" v-if="isInvalidEnd">
            invalid barcode
          </div>
        </div>
        <div class="col-12" v-if="!isInvalidStart && !isInvalidEnd">
          <Alert class="mt-3">
            {{numberOfBarcodes}} barcodes
          </Alert>
        </div>
      </div>
      <Alert variant="danger" class="tw:mb-0">
        <a href v-on:click.prevent="deleteRange" class="text-danger">delete barcodes config</a>
      </Alert>
    </div>
  </div>
</template>
<script>
import Alert from "@/components/ui/Alert.vue";

export default{
  components: {Alert},
  props: ['config'],
  data() {
    return {
      id: null,
      start: null,
      end: null,
      size: null,
      selectedType: null,
      barcodeTypes: [
        { name:"EAN-8", size: 7 },
        { name:"CODE-128", size: null },
        { name:"LUHN", size: null },
      ]
    };
  },
  computed: {
    displayBarcodeLength : function () {
      if(!this.selectedType) return false;
      if(this.selectedType.size === null) {
        return true;
      }
    },
    type: function() {
        if(!this.selectedType) return null;
        return this.selectedType.name;
    },
    selectedTypeValue: function()
    {
        if(this.selectedType) {
            return this.selectedType.name
        }
        return null;
    },
    barcodeLength: function() {
      if(!this.selectedType) return null;
      if(this.selectedType.size === null) {
          return parseInt(this.size);
      }
      return this.selectedType.size;
    },
    isInvalidStart: function() {
      return !this.checkLength(this.start);
    },
    isInvalidEnd: function() {
      return !(this.checkLength(this.end) && (this.end > this.start));
    },
    numberOfBarcodes: function() {
      return this.end - this.start + 1;
    }
  },
  methods: {
    SelectType(e) {
        this.selectedType = _.find(this.barcodeTypes, {name: e.target.value});
        this.updateRange();
    },
    updateRange() {
      this.$emit('range-updated', {
        id: this.id,
        type: this.type,
        size: this.size,
        start: this.start,
        end: this.end,
      })
    },
    deleteRange() {
      this.$emit('range-deleted');
    },
    checkLength(barcode) {
      if(!this.type) return false;
      if(!barcode) return false;
      let barcodeType = _.find(this.barcodeTypes, {name: this.type});
      if(barcodeType.size) {
          return barcode.length === barcodeType.size;
      }
      return barcode.length === parseInt(this.size);
    },
  },
  mounted() {
    this.id = this.config.id;
    this.selectedType = _.find(this.barcodeTypes, {name: this.config.type});
    if(this.selectedType && this.selectedType.size) {
        this.size = this.selectedType.size;
    } else {
        this.size =  parseInt(this.config.size);
    }
    this.start = this.config.start;
    this.end = this.config.end;
  }
}

</script>
